import * as yup from 'yup';

import { validCompanyNameRegex } from 'src/common/constants/admin/corporate';
import { isValidURL } from 'src/common/helpers';

import { companyTypeOptions } from '../../corporate.constants';

export const updateCompanyDetailsFormValidation = yup.object({
  companyName: yup
    .string()
    .required('Company name is required.')
    .min(2, 'Company name must be at least 2 characters long.')
    .matches(validCompanyNameRegex, 'Invalid company name.'),
  url: yup
    .string()
    .required('Company website is required.')
    .test('url-validation', 'Please enter a valid company website', (value) => isValidURL(value ?? '')),
  type: yup
    .string()
    .required('Please select company type')
    .oneOf(
      companyTypeOptions.map((option) => option.value),
      'Invalid company type',
    ),
});
